import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Icon, Loader } from 'rsuite';

import { selectorUser } from '../../lib/selectorUser';
import { getInitialRoute } from '../../utils/userSession';
import { useLinkAccess } from './hooks/useLinkAccess';
import styles from './LinkAcesso.module.scss';
import { LinkAccessErrorStatus } from './types';

const ERROR_MESSAGES: Record<LinkAccessErrorStatus, string> = {
  invalid: 'Link inválido. Confira o endereço recebido.',
  notFound: 'Link inválido, já usado, revogado ou expirado.',
  forbidden: 'Este link foi emitido para outro colaborador.',
  unavailable: 'Técnico indisponível. Tente novamente mais tarde.',
  failure: 'Não foi possível acessar pelo link. Tente novamente.',
};

export const LinkAcesso = () => {
  const history = useHistory();
  const collaborator = useSelector(selectorUser);
  const status = useLinkAccess();

  const handleBack = () => {
    history.replace((collaborator && getInitialRoute(collaborator)) || '/login');
  };

  if (status === 'loading') {
    return (
      <div className={styles.container}>
        <Loader size="md" content="Validando link..." vertical />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Icon icon="exclamation-circle" className={styles.icon} />
        <p className={styles.message}>{ERROR_MESSAGES[status]}</p>
        <Button appearance="primary" onClick={handleBack}>
          Voltar
        </Button>
      </div>
    </div>
  );
};
